export const ENV = process.env.NODE_ENV;
